export enum ECreateImageActionType {
  CreateNodeInCell,
  SplitTextCreateNode,
}
